import { ChangeDetectorRef, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { EventBusService } from '../../../services/event-bus.service';

/**
 * App confirm dialog component
 */
@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './app-confirm-dialog.component.html',
  styleUrls: ['./app-confirm-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None //Important: Keep allin main scss class!
})
export class AppConfirmDialogComponent implements OnInit {
  /**
  * Confirmation dialog configuration
  */
  config: any;

  /**
  * Confirmation dialog custom message
  */
  customMessage: string | null;

  /**
  * Flag indicating  if the confirmation button should be displayed
  */
  showConfirmButton = true;

  /**
  * Confirmation dialog title
  */
  translationKeyTitle = '';

  /**
  * Confirmation dialog message
  */
  translationKeyMessage = '';

  /**
  * Confirmation dialog confirm button title
  */
  translationKeyConfirm = '';

  /**
  * Confirmation dialog cancel button title
  */
  translationKeyCancel = '';

  /**
  * Flag indicating if the confirmation dialog should be displayed
  */
  isDialogOpened = false;

  /**
   * Constructor
   * @param _translate TranslateService
   */
  constructor(private eventBus: EventBusService, private _ref: ChangeDetectorRef, private _translate: TranslateService) { }

  /**
   * Oninit
   */
  ngOnInit() {
    this.eventBus.subscribeEvent('openConfirmDialog', (config, translationKey) => {
      this.reset();
      this.config = config;
      this.translationKeyTitle = this._translate.instant(`${translationKey}.title`);
      this.translationKeyMessage = this._translate.instant(`${translationKey}.message`);
      this.translationKeyConfirm = this._translate.instant(`${translationKey}.confirm`);
      this.translationKeyCancel = config.cancel ? this._translate.instant(`${translationKey}.cancel`) : '';
      this.isDialogOpened = true;

      if (config.customMessage) {
        this.customMessage = config.customMessage();
      }

      if (config.hideConfirmButton) {
        this.showConfirmButton = false;
      }
      this._ref.markForCheck();
    });
  }

  /**
   * On confirm action
   */
  confirm() {
    if (this.config?.success) {
      this.config.success();
      this.isDialogOpened = false;
      this.reset();
    }
  }

  /**
   * On cancel action
   */
  cancel() {
    this.isDialogOpened = false;
    this.reset();
    this.config.cancel();
    this.eventBus.broadcastEvent('enableSaveButtonIfRequired');
  }

  /**
   * Resets the dialog
   */
  private reset(): void {
    this.customMessage = '';
    this.showConfirmButton = true;
  }
}
